// extracted by mini-css-extract-plugin
export default {"App":"App_App__2+VHF","mainContainer":"App_mainContainer__ale26","main":"App_main__5VZ13"};